module.exports = __webpack_public_path__ + "img/blue_171.24f740ee.png";